"use client";
import { MagnifyingGlassPlusIcon } from "@heroicons/react/24/outline";
import Image from "next/image";

export default function PhotoCardComp({
  item,
  onClick,
}: {
  item: any;
  onClick: any;
}) {
  return (
    <div
      className="relative cursor-pointer group border-8 border-solid border-white bg-white shadow-sm"
      onClick={() => onClick(item)}
    >
      <div className="absolute z-20 w-full h-full opacity-0 bg-white bg-opacity-45 flex justify-center items-center group-hover:opacity-100">
        <MagnifyingGlassPlusIcon className="size-8 text-dark" />
      </div>
      <Image
        src={item.imageSrc}
        alt={`${item.caption || "kehutanan"} ${item.id}`}
        width={300}
        height={200}
        className="object-cover w-full h-80 mb-2"
      />
      <div className="h-12 overflow-hidden">
        {item?.caption && (<p className="line-clamp-2 break-words">{item.caption}</p>)} 
      </div>
    </div>
  );
}
